var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[(_vm.page)?_c('blocks-list',{attrs:{"blocks":_vm.page.blocks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }